<script lang="ts">
import StatusBadge from '@/V2/components/status/StatusBadge.vue';
import { Statuses } from '@/V2/components/status/utils';
import {
  mapComplianceResultToStatus,
  mapComplianceResultToLabel,
} from '@/V2/customers/business-compliance-agent/utils';
export default {
  name: 'CustomerComplianceBadge',
  components: { StatusBadge },
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    return {
      mapComplianceResultToStatus,
      mapComplianceResultToLabel,
      customer: props.customer,
      Statuses,
    };
  },
};
</script>

<template>
  <div class="customer-compliance-badge">
    <status-badge
      :state="
        mapComplianceResultToStatus(
          customer.business_compliance_agent_v1?.output?.result,
        ) || Statuses.DISABLED
      "
      :label="
        mapComplianceResultToLabel(
          customer.business_compliance_agent_v1?.output?.result,
        ) || 'No Rating'
      "
    />
  </div>
</template>
